export default {
  ROLE_GUEST: 0b0,
  ROLE_MEMBER: 0b1, // 1
  ROLE_DEPARTMENT_MASTER: 0b1000,
  ROLE_TYPIST: 0b10000,
  ROLE_RESIDENT: 0b100000,
  ROLE_ASSISTANT: 0b100000,
  ROLE_STAFF: 0b1000000,
  ROLE_ACCOUNT: 0b100,
  ROLE_ADMIN: 0b1000000000000000000000000000000
};




export const ROLE_GUEST = 0b0; // 0
export const ROLE_MEMBER = 0b1; // 1
export const ROLE_EXPERT = 0b10; // 2
export const ROLE_ACCOUNT = 0b100; // 4
export const ROLE_DEPARTMENT_MASTER = 0b1000; // 8
export const ROLE_TYPIST = 0b10000; // 16
export const ROLE_RESIDENT = 0b100000; // 32
export const ROLE_ASSISTANT = 0b100000; // 32
export const ROLE_STAFF = 0b1000000; // 64
export const ROLE_IT = 0b10000000; // 128
export const ROLE_PACS_ADMIN = 0b100000000; // 256
export const ROLE_ALL = 0b1111111111111111111111111111111;
export const ROLE_ADMIN = 0b1000000000000000000000000000000;
